import { memo } from 'react';

interface CardPreviewContentProps {
  html: string;
}

function hexToHSL(hex: string): [number, number, number] {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  const l = (max + min) / 2;
  if (max === min) return [0, 0, l * 100];
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h = 0;
  if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
  else if (max === g) h = ((b - r) / d + 2) / 6;
  else h = ((r - g) / d + 4) / 6;
  return [h * 360, s * 100, l * 100];
}

export function colorGradient(hex: string): string {
  const [h, s, l] = hexToHSL(hex);
  const from = `hsl(${h - 15}, ${Math.min(s + 10, 100)}%, ${l}%)`;
  const to = `hsl(${h + 15}, ${s}%, ${Math.max(l - 8, 15)}%)`;
  return `linear-gradient(135deg, ${from}, ${to})`;
}

const CardPreviewContent = memo<CardPreviewContentProps>(function CardPreviewContent({ html }) {
  return <div suppressHydrationWarning dangerouslySetInnerHTML={{ __html: html }} />;
});

export default CardPreviewContent;
